import logo from "../../images/p3.png"


export default function P3() {
  return (
    <img className="p" src={logo} alt="contact logo" />
   
  );
}